import { useEffect, useState } from "react";

const useBlueRate = () => {
    const [blueRate, setBlueRate] = useState(null);

    useEffect(() => {
    const fetchBlue = async () => {
        const res = await fetch("https://dolarapi.com/v1/dolares/blue");
        const data = await res.json();
        localStorage.setItem("blueRate", JSON.stringify({
        value: data.venta,
        timestamp: Date.now()
        }));
        setBlueRate(data.venta);
    };

    const stored = localStorage.getItem("blueRate");

    if (stored) {
        const parsed = JSON.parse(stored);
        const tenMinutes = 10 * 60 * 1000;

        if (Date.now() - parsed.timestamp < tenMinutes) {
        setBlueRate(parsed.value);
        return;
        }
    }

    fetchBlue();
    }, []);


  return blueRate;
};

export default useBlueRate;
